import React from 'react';
import PoojaBooking from '../reportSection/pooja/poojaBooking';
import DailyReport from '../reportSection/pooja/dailyReport';
import PoojaBookingReport from '../reportSection/pooja/poojabookingReport';
import PoojaBookingSummary from '../reportSection/pooja/poojaBookingSummary';
import SummaryBySignInName from '../reportSection/pooja/summaryBySignInName';
import DonationReport from '../reportSection/treasury/DonationReport';
import LifeTimeDonorReport from '../reportSection/treasury/LifeTimeDonorReport';
import DailyCheckReceiptReport from '../reportSection/treasury/DailyCheckReceiptReport';
import RevenueSummaryReport from '../reportSection/treasury/RevenueSummaryReport';
import IncomeReport from '../reportSection/treasury/IncomeReport';
import MailingLabelsReport from '../reportSection/devotee/MailingLabelsReport';
import DevoteeReport from '../reportSection/devotee/DevoteeReport';
import AbhishekamReport from '../reportSection/devoteeSponsorship/AbhishekamReport';
import AnnualAbhisekhamReport from '../reportSection/devoteeSponsorship/AnnualAbhisekhamReport';
import AnnualAbhisekhamExpiryReport from '../reportSection/devoteeSponsorship/AnnualAbhisekhamExpiryReport';
import MonthlyAbhishekaReport from '../reportSection/devoteeSponsorship/MonthlyAbhishekaReport';
import ArchanaReport from '../reportSection/devoteeSponsorship/ArchanaReport';
import BirthdayPoojaReport from "../reportSection/devotee/BirthdayPoojaReport";
import PriestBookingConsolidatedReport from '../reportSection/priest/priestBookingConsolidatedReport';
import PriestBookingReport from '../reportSection/priest/priestBookingReport';
import { Box } from '@mui/material';
import SpecialEventDonationReport from '../reportSection/treasury/SpecialEventDonationReport';
import DonationReportForDevoteeInformation from '../reportSection/devoteeSponsorship/DonationReportForDevoteeInformation';
import EventsAndMahaPrasadamReport from '../reportSection/treasury/EventsAndMahaPrasadamReport';
import IncomeReportForFrontDesk from '../reportSection/frontDesk/IncomeReportForFrontDesk';
import VendorReport from '../reportSection/systemReports/VendorReport';
import YearEndDonationReport from '../reportSection/devoteeSponsorship/YearAndDonationReport';
import RevenueReport from '../reportSection/treasury/RevenueReport';
import RevenueSummaryBySignInName from '../reportSection/treasury/RevenueSummaryBySignInName';
import VolunteerReport from '../reportSection/Volunteers/VolunteerReport';
import VastraReport from '../reportSection/treasury/VastraReport';
import InventoryReport from '../reportSection/systemReports/InventoryReport';
import Statistics from '../reportSection/systemReports/Statistics';
import PriestDutiesConsolidated from '../reportSection/priest/PriestDutiesConsolidated';
import PriestScheduleSummaryIndividual from '../reportSection/priest/PriestScheduleSummaryIndividual';
import EventRegistrations from '../reportSection/Others/EventRegistrations';

const components:any = {
    POOJA_BOOKING: PoojaBooking,
    POOJA_BOOKING_REPORT: PoojaBookingReport,
    POOJA_BOOKING_SUMMARY_BY_SIGN_IN_NAME: SummaryBySignInName,
    POOJA_BOOKING_SUMMARY: PoojaBookingSummary,
    POOJA_BOOKING_DAILY_REPORT: DailyReport,
    DONATION_REPORT: DonationReport,
    LIFETIME_DONORS_REPORT: LifeTimeDonorReport,
    DAILY_CHECK_RECEIPT_REPORT: DailyCheckReceiptReport,
    INCOME_REPORT: IncomeReport,
    REVENUE_SUMMARY_REPORT: RevenueSummaryReport,
    PRIESTS_SCHEDULE_SUMMARY_CONSOLIDATED: PriestBookingConsolidatedReport,
    PRIEST_BOOKING_REPORT: PriestBookingReport,
    MAILING_LABELS: MailingLabelsReport,
    DEVOTEE_REPORT: DevoteeReport,
    ANNUAL_ABHISHEKA: AnnualAbhisekhamReport,
    ABHISHEKAM_REPORT: AbhishekamReport,
    ANNUAL_ABHISHEKA_EXPIRY_REMINDERS: AnnualAbhisekhamExpiryReport,
    MONTHLY_ABHISHEKA: MonthlyAbhishekaReport,
    ARCHANA_REPORTS: ArchanaReport,
    BIRTHDAY_POOJA_REPORT: BirthdayPoojaReport,
    SPECIAL_EVENT_DONATION_REPORT : SpecialEventDonationReport,
    DONATION_REPORTS_FOR_DEVOTEE_INFORMATION : DonationReportForDevoteeInformation,
    EVENTS_AND_MAHAPRASADAM_DONATION_REPORT : EventsAndMahaPrasadamReport,
    INCOME_REPORT_FOR_FRONT_DESK:IncomeReportForFrontDesk,
    YEAR_END_DONATION_REPORT:YearEndDonationReport,
    REVENUE_REPORTS:RevenueReport,
    VENDOR_REPORT:VendorReport,
    REVENUE_SUMMARY_REPORT_BY_SIGNIN_NAME:RevenueSummaryBySignInName,
    VOLUNTEERS:VolunteerReport,
    VASTRA_REPORT: VastraReport,
    INVENTORY_REPORT:InventoryReport,
    STATISTICS:Statistics,
    PRIEST_DUTIES_CONSOLIDATED: PriestDutiesConsolidated,
    PRIEST_SCHEDULE_SUMMARY_INDIVIDUAL:PriestScheduleSummaryIndividual,
    EVENT_REGISTRATIONS:EventRegistrations

};
  
  export function ReportToRender(key:any, handleDataFromChild:any, getReportData:any,getReqBodyAndResData?:any) {
    const SpecificReport = components[key];
    if (SpecificReport) {
      return <SpecificReport sendDataToParent={handleDataFromChild} getReportData={getReportData}
      getReqBodyAndResData={getReqBodyAndResData} />;
    }
    return <Box sx={{color:"red"}}>Report not found</Box>
  };